export function pct(val: any): string {
  if (val == null || val === '') return '—';
  return `${Math.round(Number(val))}%`;
}

export function fmtMoney(n: any): string {
  if (n == null) return '—';
  return `$${Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function fmtPct(n: any): string {
  if (n == null) return '—';
  return `${Math.round(Number(n))}%`;
}

export function fmtMiles(n: any): any {
  if (n && typeof n.toFixed === 'function') return n.toFixed(1);
  return n != null ? n : '—';
}

export function withPercentOfTotal(rows: any[], valueKey = 'totalJobs'): any[] {
  if (!rows || !rows.length) return [];
  const total = rows.reduce((sum, row) => sum + (Number(row[valueKey]) || 0), 0);
  return rows.map((row) => ({
    ...row,
    percentOfTotal: total
      ? Number((((Number(row[valueKey]) || 0) / total) * 100).toFixed(1))
      : 0
  }));
}

export function sumField(rows: any[], field: string): number {
  return (rows || []).reduce((sum, row) => sum + (Number(row[field]) || 0), 0);
}

export function driverDisplayName(driver: any): string {
  if (!driver) return '—';
  if (typeof driver === 'object') {
    return driver.displayName || `${driver.firstName || ''} ${driver.lastName || ''}`.trim() || '—';
  }
  return '—';
}

export function driverProfileImage(row: any): string {
  if (!row) return '';
  if (row.driver && typeof row.driver === 'object') {
    return row.driver.profileImageURL || '';
  }
  if (typeof row._id === 'object' && row._id && row._id.profileImageURL) {
    return row._id.profileImageURL || '';
  }
  if (typeof row === 'object' && row.profileImageURL) {
    return row.profileImageURL;
  }
  return '';
}

export function cooperateDisplayName(row: any): string {
  const cooperate = row.cooperate || (typeof row._id === 'object' ? row._id : null);
  if (cooperate && typeof cooperate === 'object') {
    return cooperate.displayName || cooperate.name || '—';
  }
  return '—';
}

export function cooperateProfileImage(row: any): string {
  if (!row) return '';
  if (row.cooperate && row.cooperate.profileImageURL) return row.cooperate.profileImageURL;
  if (typeof row._id === 'object' && row._id && row._id.profileImageURL) {
    return row._id.profileImageURL;
  }
  return '';
}

export function fleetDisplayName(row: any): string {
  const fleet = row.fleet || (typeof row._id === 'object' ? row._id : null);
  if (fleet && typeof fleet === 'object') {
    const name = fleet.driverCarModel || fleet.setiDecall || fleet.displayName || '—';
    if (fleet.vehicleTrackingNumber) {
      return `${name} (TN: ${fleet.vehicleTrackingNumber})`;
    }
    return name;
  }
  return '—';
}

export function fleetVin(row: any): string {
  const fleet = row.fleet || (typeof row._id === 'object' ? row._id : null);
  if (!fleet || typeof fleet !== 'object') return '';
  return fleet.vin || '';
}

export function fleetProfileImage(row: any): string {
  if (!row) return '';
  const fleet = row.fleet || (typeof row._id === 'object' ? row._id : null);
  if (!fleet || typeof fleet !== 'object') return '';
  return fleet.profileImageURL || '';
}

/** revenueKpis → { summary, sources } */
export function parseRevenueKpis(revenueKpis: any): { summary: any; sources: any[] } {
  const block = Array.isArray(revenueKpis) ? revenueKpis[0] : revenueKpis;
  if (!block) return { summary: {}, sources: [] };
  return { summary: block, sources: block.sources || [] };
}

/** driverRevenueKpis → { summary, sources } */
export function parseDriverRevenueKpis(driverRevenueKpis: any): { summary: any; sources: any[] } {
  const block = Array.isArray(driverRevenueKpis) ? driverRevenueKpis[0] : driverRevenueKpis;
  if (!block) return { summary: {}, sources: [] };
  return { summary: block, sources: block.sources || [] };
}

export function timelineStatusLabel(status: string): string {
  const labels: any = {
    open: 'Checked In',
    paused: 'Paused',
    completed: 'Completed',
    none: 'Active',
    rest: 'Rest'
  };
  return labels[status] || status || 'Checked In';
}

export function timelineStatusBadge(status: string): string {
  if (status === 'completed') return 'success';
  if (status === 'paused' || status === 'rest') return 'warning';
  if (status === 'rejected') return 'danger';
  return 'info';
}

export function formatCheckInTime(checkin: any): string {
  if (!checkin) return '—';
  return new Date(checkin).toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit'
  });
}

export function formatHours(value: any): string {
  if (value == null) return '—';
  return Number(value).toFixed(1);
}

export function millisToHours(ms: any): number {
  if (ms == null) return null;
  return Number((Number(ms) / 3600000).toFixed(1));
}

export function breakdownRowName(row: any, nameField: string): string {
  const entity = row[nameField];
  if (!entity) return 'Unassigned';
  return entity.displayName || entity.name || entity.title || '—';
}
